import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-camera-meta-data',
  templateUrl: './camera-meta-data.component.html',
  styleUrls: ['./camera-meta-data.component.css']
,
  standalone: false
})
export class CameraMetaDataComponent implements OnInit {
  @Input() cameraMetadata:any
  showCustomPopup = false;
  constructor() { }

  ngOnInit(): void {}


  copyDetails(text: string) {
    this.showCustomPopup = true;
    setTimeout(() => this.showCustomPopup = false, 3000);
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = text;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }
}
